"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  CollaboratorsQuery: () => CollaboratorsQuery,
  LabelsQuery: () => LabelsQuery,
  MessagesQuery: () => MessagesQuery,
  NotificationContextsQuery: () => NotificationContextsQuery,
  NotificationsQuery: () => NotificationsQuery
});
module.exports = __toCommonJS(query_exports);
var import_fast_equals = require("fast-equals");
var import_init = require("./init");
class BaseQuery {
  static {
    __name(this, "BaseQuery");
  }
  oldParams;
  oldOptions;
  oldCallback;
  constructor(dontDestroy) {
    if (dontDestroy !== true) {
      const destroyFn = (0, import_init.getOnDestroy)();
      destroyFn(() => {
        this.unsubscribe();
      });
    }
  }
  _unsubscribe = /* @__PURE__ */ __name(() => {
  }, "_unsubscribe");
  unsubscribe() {
    this._unsubscribe(false);
  }
  query(params, callback, options) {
    if (!this.needUpdate(params, callback, options)) {
      return false;
    }
    this.doQuery(params, callback, options);
    return true;
  }
  doQuery(params, callback, options) {
    const isUpdate = this.oldParams !== void 0;
    this._unsubscribe(isUpdate);
    this.oldCallback = callback;
    this.oldParams = params;
    this.oldOptions = options;
    const { unsubscribe } = this.createQuery(params, callback, options);
    this._unsubscribe = (isUpdate2) => {
      unsubscribe(isUpdate2);
      this.oldCallback = void 0;
      this.oldParams = void 0;
      this.oldOptions = void 0;
      this._unsubscribe = () => {
      };
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createQuery(params, callback, options) {
    return {
      unsubscribe: /* @__PURE__ */ __name(() => {
      }, "unsubscribe")
    };
  }
  needUpdate(params, callback, options) {
    if (!(0, import_fast_equals.deepEqual)(params, this.oldParams)) return true;
    if (!(0, import_fast_equals.deepEqual)(options, this.oldOptions)) return true;
    if (!(0, import_fast_equals.deepEqual)(callback.toString(), this.oldCallback?.toString())) return true;
    return false;
  }
}
class MessagesQuery extends BaseQuery {
  static {
    __name(this, "MessagesQuery");
  }
  createQuery(params, callback, options) {
    return (0, import_init.getLiveQueries)().queryMessages(params, callback, options);
  }
}
class NotificationsQuery extends BaseQuery {
  static {
    __name(this, "NotificationsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryNotifications(params, callback);
  }
}
class NotificationContextsQuery extends BaseQuery {
  static {
    __name(this, "NotificationContextsQuery");
  }
  createQuery(params, callback, options) {
    return (0, import_init.getLiveQueries)().queryNotificationContexts(params, callback, options);
  }
}
class LabelsQuery extends BaseQuery {
  static {
    __name(this, "LabelsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryLabels(params, callback);
  }
}
class CollaboratorsQuery extends BaseQuery {
  static {
    __name(this, "CollaboratorsQuery");
  }
  createQuery(params, callback) {
    return (0, import_init.getLiveQueries)().queryCollaborators(params, callback);
  }
}
//# sourceMappingURL=query.js.map
